import React, {useEffect, useState} from "react";
import styles from './login.module.css';
import {PrimaryButton, TextInput} from "../../components/input/inputs";
import {Link} from "react-router-dom";
import axiosInstance from "../../AxiosInstance";

export default function Login() {
    const [showError, setShowError] = useState(false);
    const [form, setForm] = useState({});
    const [systemSettings, setSystemSettings] = useState({});
    const [doLogin, setDoLogin] = useState(false);

    const handleKeyPress = (event) => {
        if (event.key === 'Enter') {
            setDoLogin(true);
        }
    }

    useEffect(() => {
        if(doLogin){
            onClick();
        }
    }, [doLogin]);

    useEffect(() => {
        window.addEventListener('keydown', handleKeyPress);

        return () => window.removeEventListener('keydown', handleKeyPress);
    }, []);

    const onClick = () => {
        axiosInstance.post('token/', {
            ...form,
            username: form.username.toLowerCase(),
        }).then((response) => {
            setShowError(false);
            localStorage.setItem('access_token', response.data.access);
            localStorage.setItem('refresh_token', response.data.refresh);
            axiosInstance.defaults.headers.common['Authorization'] = `Bearer ${response.data.access}`;

            axiosInstance.get('current_user/').then((response2) => {
                if(response2.status !== 200) {
                    localStorage.setItem("system_settings", "{\"image\":null,\"main_color\":\"#FF1235\",\"fade_start\":\"#7376CA\",\"secondary_color\":\"#6E70C8\"}");
                    return;
                }
                localStorage.setItem('company_factoring_approved', response2.data.company_factoring_approved.toString());
                localStorage.setItem('seller_uuid', response2.data.seller_uuid.toString());
                localStorage.setItem('system_settings', JSON.stringify(response2.data.company));
                window.location.replace('/provider/buy_order')
            });
        }).catch((err) => {
            setShowError(true);
        })
    }

    return (
        <div className={styles.mainContainer}>
            <div className={styles.provider} style={{backgroundImage: "url('images/login_background.png')"}}>
                <div style={{width: '100%'}} className={'mt-5'}>
                    <img src={systemSettings?.image}/>
                    <div style={{color: '#FFF', fontSize: '1.4rem'}}>Ecosistema que involucra los <br/>principales actores del factoring</div>
                </div>
            </div>
            <div className={styles.login}>
                <div className={`${styles.title} mb-4`}>Portal de Proveedores</div>

                <div className={styles.loginBox}>
                    <div className={styles.loginTitle}>Iniciar sesión</div>
                    <div className={`mt-1 mb-3`}>Por favor, introduce tu RUC, usuario y contraseña</div>

                    <div>
                        <TextInput name={'RUC'} internalName={'ruc'} form={form} hideName={true} setForm={setForm} placeholder={'Ingresa el número de RUC de tu empresa'}/>
                        <TextInput name={'CORREO'} internalName={'username'} hideName={true} form={form} setForm={setForm} placeholder={'Ingresa tu correo electrónico'}/>
                        <TextInput name={'CONTRASEÑA'} type={'password'} hideName={true} internalName={'password'} form={form} setForm={setForm} placeholder={'Ingresa tu contraseña'}/>

                        <div className={'d-flex flex-row align-items-end'}>
                            {/*<div role={'button'} className={'mb-3'} style={{color: "#4A4DB9", fontWeight: "700"}}>¿Olvidaste tu contraseña?</div>*/}
                        </div>
                        <PrimaryButton name={'Iniciar sesión'} onClick={onClick}/>

                        <div className={'d-flex flex-row align-items-end'}>
                            {showError && <div className={'mb-3'} style={{color: "#b94a4a", fontWeight: "700"}}>Credenciales inválidas. Inténtalo de nuevo.</div>}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}